export default __webpack_public_path__ + "static/media/Student-new.84112c6f.png";